import type {Session} from '../../../types/session'
import {ownerAvatarPath} from '@github-ui/paths'
import {ExpandableMarkdown} from '../../expandable-markdown/ExpandableMarkdown'
import styles from './UserProblemStatementMessage.module.css'
import {useAgentInfo} from '@github-ui/copilot-shared-ui/agents/use-agent-info'
import {createMarkdownWithAgentLinks} from '../../../utils/markdown-link-utils'
import {useCurrentUser} from '../../../contexts/CurrentUserContext'
import {UserMessageLoading} from './UserMessageLoading'
import {UserMessageLayout} from './UserMessageLayout'

interface UserProblemStatementMessageProps {
  session: Session
  isLoading?: boolean
}

const ErrorMessage = () => (
  <UserMessageLayout>
    <p className={styles.messageText}>Failed to fetch problem statement</p>
  </UserMessageLayout>
)

export const UserProblemStatementMessage = ({session, isLoading = false}: UserProblemStatementMessageProps) => {
  const {data: agentInfo} = useAgentInfo(session.agent_id, session.agent_slug)
  const {currentUser} = useCurrentUser()

  if (!session.event_content) {
    return isLoading ? <UserMessageLoading /> : <ErrorMessage />
  }

  const getAuthorDisplayLogin = () => {
    if (currentUser && session.user_id === currentUser.id) {
      return 'You'
    }

    return session.user_login ?? 'User'
  }

  const avatarUrl =
    currentUser && session.user_id === currentUser.id
      ? currentUser.primaryAvatarUrl
      : ownerAvatarPath({owner: session.user_login ?? 'ghost'})

  // Process markdown with agent links if needed
  const markdownContent = agentInfo
    ? createMarkdownWithAgentLinks(session.event_content ?? '', agentInfo)
    : (session.event_content ?? '')

  return (
    <UserMessageLayout avatarUrl={avatarUrl}>
      <span className={styles.messageMeta}>{getAuthorDisplayLogin()} asked</span>
      <ExpandableMarkdown className={styles.messageText} markdown={markdownContent} />
    </UserMessageLayout>
  )
}
